import '../scss/styles.scss';
import accordion from './module/accordion'
import accordionLight from './module/_accordion_light'
import navigation from './module/navigation'
// import cookiebanner from './module/cookiebanner'
import carousel from './module/carousel'
import custom from './module/custom'
import status from './module/status'
import weather from './module/weather'
import aos from './module/aos'
import topbutton from './module/top-button'
import comfort from './module/comfort';
import './module/datepicker';
import './module/cookiebar';